export const HEALTH_REQUEST = 'HEALTH_REQUEST';
export const HEALTH_SET_DEPENDENT_PERSON = 'HEALTH_SET_DEPENDENT_PERSON';
export const HEALTH_SET_CARE_LEVEL = 'HEALTH_SET_CARE_LEVEL';
export const HEALTH_TOGGLE_CARE_LEVEL_MODAL = 'HEALTH_TOGGLE_CARE_LEVEL_MODAL';
